module.exports = __webpack_public_path__ + "static/media/ftfMartha.353b79cf.md";